<template>
  <div>
    <div class="ch-scrim" @click="$emit('close')"></div>
    <div class="ch-bottom-sheet ch-chat-sheet">
      <div class="ch-sheet-grabber mx-auto mb-3"></div>

      <div class="d-flex align-items-center justify-content-between mb-3 pb-3 border-bottom px-4">
        <div>
          <h3 class="mb-0 body-1-4">Contact us</h3>
          <p class="color-grey mb-0 body-3">
            Our concierge team is ready to assist you anytime.
          </p>
        </div>
        <button @click="$emit('close')" class="ch-close-btn" type="button">
          <i class="simple-icon-close" style="font-size:13px"></i>
        </button>
      </div>

      <div class="px-4 pb-5" style="display:flex;flex-direction:column;gap:10px">
        <!-- Email -->
        <button
          @click="$emit('email')"
          class="ch-contact-option w-100 d-flex align-items-center rounded-6 p-3"
          type="button"
        >
          <div class="ch-contact-icon ch-contact-icon--email mr-3 flex-shrink-0 d-flex align-items-center justify-content-center">
            <Mail :size="20" :stroke-width="2" />
          </div>
          <div class="flex-grow-1 text-left">
            <p class="mb-0 font-bold" style="font-size:14px">Email</p>
            <p class="mb-0 color-grey" style="font-size:12px">Send us a message anytime</p>
          </div>
          <i class="simple-icon-arrow-right color-grey flex-shrink-0" style="font-size:11px"></i>
        </button>

        <!-- WhatsApp -->
        <button
          @click="$emit('whatsapp')"
          class="ch-contact-option w-100 d-flex align-items-center rounded-6 p-3"
          type="button"
        >
          <div class="ch-contact-icon ch-contact-icon--wa mr-3 flex-shrink-0 d-flex align-items-center justify-content-center">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
              <path d="M12 2C6.477 2 2 6.477 2 12c0 1.89.52 3.658 1.424 5.173L2 22l4.944-1.396A9.953 9.953 0 0 0 12 22c5.523 0 10-4.477 10-10S17.523 2 12 2zm0 18a7.95 7.95 0 0 1-4.045-1.104l-.29-.172-3.035.857.818-3.118-.188-.302A7.954 7.954 0 0 1 4 12c0-4.418 3.582-8 8-8s8 3.582 8 8-3.582 8-8 8zm4.406-5.908c-.242-.12-1.43-.705-1.651-.785-.222-.08-.383-.12-.545.12-.161.242-.626.785-.767.946-.141.162-.282.182-.524.06-.242-.12-1.02-.376-1.943-1.198-.718-.64-1.203-1.43-1.344-1.672-.14-.242-.015-.373.106-.493.109-.108.242-.282.363-.424.12-.141.161-.242.242-.403.08-.162.04-.303-.02-.424-.06-.12-.545-1.312-.747-1.797-.196-.47-.396-.406-.545-.414l-.464-.008c-.161 0-.424.06-.646.303-.222.242-.847.828-.847 2.02s.867 2.344.988 2.505c.12.161 1.706 2.606 4.134 3.653.578.25 1.029.398 1.38.51.58.184 1.108.158 1.525.096.465-.07 1.43-.584 1.632-1.149.201-.565.201-1.049.14-1.149-.06-.1-.221-.161-.463-.282z"/>
            </svg>
          </div>
          <div class="flex-grow-1 text-left">
            <p class="mb-0 font-bold" style="font-size:14px">WhatsApp</p>
            <p class="mb-0 color-grey" style="font-size:12px">Chat with our staff directly</p>
          </div>
          <i class="simple-icon-arrow-right color-grey flex-shrink-0" style="font-size:11px"></i>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
  import { Mail } from 'lucide-vue'

  export default {
    name: 'ConciergeChatSheet',
    components: { Mail },
  }
</script>

<style scoped>
.ch-scrim {
  position: fixed;
  inset: 0;
  background: rgba(20,15,10,0.5);
  backdrop-filter: blur(2px);
  z-index: 1055;
}

.ch-bottom-sheet {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1056;
  background: #fff;
  border-top-left-radius: 24px;
  border-top-right-radius: 24px;
  padding-top: 12px;
  box-shadow: 0 -10px 40px rgba(0,0,0,0.18);
  max-height: 90vh;
  overflow-y: auto;
  animation: sheetUp .25s ease-out;
}

.ch-chat-sheet {
  padding-bottom: env(safe-area-inset-bottom, 0px);
}

.ch-sheet-grabber {
  width: 40px;
  height: 4px;
  border-radius: 99px;
  background: #E0E8EF;
  display: block;
}

.ch-close-btn {
  width: 34px;
  height: 34px;
  border-radius: 999px;
  background: #F3F6F9;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #1C2B36;
}

.ch-contact-option {
  background: #FFFFFF;
  border: 1.5px solid #E0E8EF;
  cursor: pointer;
  font-family: inherit;
  color: #1C2B36;
  transition: background 0.15s, border-color 0.15s;
  -webkit-tap-highlight-color: transparent;
}

.ch-contact-option:active {
  background: #F3F6F9;
  border-color: var(--merchant-primary-color, #2B5F7A);
}

.ch-contact-icon {
  width: 44px;
  height: 44px;
  border-radius: 13px;
  flex-shrink: 0;
}

.ch-contact-icon--email {
  background: #EAF4FB;
  color: #2A8FA8;
  border: 1px solid #C5E3F0;
}

.ch-contact-icon--wa {
  background: #E8F5E9;
  color: #25D366;
  border: 1px solid #B2DFBC;
}

@keyframes sheetUp {
  from { transform: translateY(100%); }
  to   { transform: translateY(0); }
}
</style>



// WEBPACK FOOTER //
// src/components/v2/ConciergeChatSheet.vue